import "leaflet/dist/leaflet.css"
import React, { Component, useState } from 'react'
import axios from "axios";
import Select from 'react-select'
import "../../config/global.js"
import TCFLayer from "./TCFLayer.js"
import {Scale, GetGrad, hasTCF, getTCFs} from "../config.js"
import {
    MapContainer, useMap,
    Polygon,
    TileLayer,
    Popup,
    ScaleControl
} from 'react-leaflet'
import GCF from '../GCF/GCF_Table';
import AsyncCSV from '../../config/ExportCSV'
import { authContext } from '../../Login/AuthContext';

var title = "Zone : Département";

export default class VectorLayersExample extends Component {
    constructor(props, auth) {
        super(props)
        this.state = {
          msg:0,
          isLoading:true,
          isLoadingTCF:true,
          isLoadingShapes:true
        }
        this.handleClick = this.handleClick.bind(this)
    }
    static contextType = authContext;

    componentDidMount = (tcf) => {
      if(global.ar2.perimeterList.length == 0)
        this.getZones()
      else {
        this.setState ({isLoading:false})
      }
      this.updateTCF()
    }

    updateTCF = async () => {
      var wait = await this.getTCFs()
      wait = await this.getShapes()
      //if(this.center != global.ar2.center)
      global.ar2.center =  await this.center
      global.wait = await global.wait + 1
    }

    getZones = () => {
      var p = global.ar2.perimeterList
      setTimeout( () => {
        axios.get("https://mel.dvrc.fr/api/GetTCFPerims.php?level=2&token="+this.context.auth.data.token)
          //.then(res => res.json())
          .then( (data) => {
            data.data.forEach(element => {
              var found=false
              for(var i=0;i<p.length;i++){
                if(p[i].value == element.gid_2)
                  found=true
              }
              if(!found)
                p.push({ value: element.gid_2, label: element.name_2 })
            })
          }).then( () => {
            global.ar2.perimeterList =  p
            this.setState ({isLoading:false})
          })
        , 3000})
    }

    getTCFs = () => {
      if(!hasTCF("ar2")){
        var url = "https://mel.dvrc.fr/api/GetTCFPerZone.php?level=2"+
          "&perim="+global.ar2.name_area+
          "&agg="+global.ar2.ag+
          "&year="+global.year+
          "&nat="+global.nat+
          "&token="+this.context.auth.data.token;
        //console.log("getTCFs", url)
        this.setState ({isLoadingTCF:true})
        setTimeout( () => {
          axios.get(url)
            .then( (data) => {
              if(!global.ar2.tcf[global.ar2.ag][global.ar2.gid_area])
                global.ar2.tcf[global.ar2.ag][global.ar2.gid_area] = {}
              if(!global.ar2.tcf[global.ar2.ag][global.ar2.gid_area][global.year])
                global.ar2.tcf[global.ar2.ag][global.ar2.gid_area][global.year] = {}
              if(!global.ar2.tcf[global.ar2.ag][global.ar2.gid_area][global.year][global.nat])
                global.ar2.tcf[global.ar2.ag][global.ar2.gid_area][global.year][global.nat] = data.data
              this.setState ({isLoadingTCF:false})
            }).then ( () => {
              this.toCSV()
              return true
            })
        , 3000})
      } else {
        this.setState ({isLoadingTCF:false})
        return true
      }
    }

    center = [0, 0]

    setCenter = async (data) => {
      if(data.features[0] && data.features[0].properties && data.features[0].properties.centroidlat){
        var maxLat = data.features[0].properties.centroidlat
        var maxLong = data.features[0].properties.centroidlong
        data.features.forEach(async (item, i) => {
          if(maxLat < item.properties.centroidlat){
            maxLat = item.properties.centroidlat
            maxLong = item.properties.centroidlong
          }
        });
        global.ar2.center = await [maxLat, maxLong]
      }
      else {
        global.ar2.center = await [0, 0]
      }
    }

    getShapes = async () => {
      if(!global.shapes.area2[global.ar2.ag][global.ar2.gid_area]){
        var url = "https://data.dvrc.fr/api/getGeoJSONunion.php?zone_type=2"+
          "&zone="+global.ar2.gid_area+
          "&agg="+global.ar2.ag+
          "&token="+this.context.auth.data.token;
        this.setState ({isLoadingShapes:true})
        setTimeout( () => {
          axios.get(url)
          .then( async (data) => {
            global.shapes.area2[global.ar2.ag][global.ar2.gid_area] = data.data
            this.setCenter(data.data)
            this.setState ({isLoadingShapes:false})
            return true
          })
        ,4000})
      } else {
        this.setCenter(global.shapes.area2[global.ar2.ag][global.ar2.gid_area])
        this.setState ({isLoadingShapes:false})
        return true
      }
    }

    csvFileName = "N4T_Department.csv"
    csvFile = "N4T_department"
    headerRegion = [
        {label:"gadm36", key:"gadm36"},
        {label:"name", key:"name"},
        {label:"year", key:"year"},
        {label:"nationality", key:"nationality"},
        {label:"TCF", key:"TCF"}
      ]

    toCSV = () => {
      var data
      if (global.ar2.ag === 3) data = global.shapes.Area3
      else if (global.ar2.ag === 4) data = global.shapes.Area4
      else if (global.ar2.ag === 5) data = global.shapes.Area5

       var dataCSV = this.context.auth.data.dataCSV;
       if(!dataCSV)
         dataCSV = [];
       dataCSV[this.csvFile] = [];

       if(data){
         data.map((element, index) => {
            if (element.properties.name_2 === global.ar2.name_area){
              var name;var gadm36;
              if (global.ar2.ag === 3) {name = element.properties.name_3;gadm36=element.properties.gid_3}
              else if (global.ar2.ag === 4) {name = element.properties.name_4;gadm36=element.properties.gid_4}
              else if (global.ar2.ag === 5) {name = element.properties.name_5;gadm36=element.properties.gid_5}

              var tcf = this.getTCF(name)
              dataCSV[this.csvFile].push({gadm36:gadm36, name:name, year:global.year, nationality:global.nat, TCF:tcf})
            }
            return ("");
          })
        }
       this.context.setAuthData(this.context.auth.data);
     }

    handleClick(year) {
        global.year = year
        this.setState(prevState => ({}));
        this.updateTCF()
    }
    handleChangeYR = selectedOption => {
        global.year = selectedOption.value
        this.setState({ selectedOption });
        this.updateTCF()
    };
    handleChangeNT = selectedOption => {
        global.nat = selectedOption.value
        this.setState({ selectedOption });
        this.updateTCF()
    };
    handleChangeAG = selectedOption => {
        global.ar2.ag = selectedOption.value
        this.setState({ selectedOption });
        this.updateTCF()
    };
    handleChangeAR = selectedOption => {
        global.ar2.name_area = selectedOption.label
        global.ar2.gid_area = selectedOption.value
        this.setState({ selectedOption });
        this.updateTCF()
    };
    handleChangeDouble = (event) =>{
        global.ar2.double = (global.ar2.double+1)%2
        this.setState();
        this.updateTCF()
    }
    handleChangeYE = selectedOption => {
        global.year = selectedOption.value
        this.setState(prevState => ({}));
        this.updateTCF()
    };

    renderLayer (){
      if(this.state.isLoading || this.state.isLoadingTCF || this.state.isLoadingShapes)
        return (<div>Loading Data</div>)

      return (<TCFLayer area="2"/>)
    }

    renderMap () {
      return (
          <div className="map">
            <MapContainer id="map" center={global.ar2.center} zoom={global.ar2.zoom}>
                <UpdateMapCentre mapCentre={global.ar2.center} />
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <ScaleControl position="bottomright" />
                {this.renderLayer()}
                <div className="map-infos">
                    <div className="grad-dep" style={{ backgroundImage: `linear-gradient(to right, rgba(${GetGrad(global.color1)}), rgba(${GetGrad(global.color2)}))` }} />
                    <span className="grad-left">&lt;{global.min}</span>
                    <span className="grad-mid" style={{ paddingLeft: Scale(1) * 100 }}>1</span>
                    <span className="grad-right">&gt;{global.max}</span>
                </div>
            </MapContainer>
            <AsyncCSV name={this.csvFileName} header={this.headerRegion} dataCSV={this.csvFile}/><br/>
            <b>Périmètre : </b> {global.ar2.name_area}<br/>
            <b>Zones : </b>{global.ar2.aggList.find(element => element.value === global.ar2.ag).label}<br/>
            <b>Nationalité : </b> {global.optionsNT.find(element => element.value === global.nat).label}<br/>
            <GCF id="GCF" action={this.handleClick} area={2} ag={global.ar2.ag} name_area={global.ar2.name_area}/>
          </div>
        )

    }

    render() {
      this.context.auth.data.csvFileName = "N4T_Department_"+global.ar2.name_area+"_"+global.ar2.ag+"_"+global.nat+"_"+global.year
      return (
            <div className="layout">
                <h1 id="title">{title}</h1>
                <div className="selector">
                    <div className="selector quart">
                      <b>Périmètre</b>
                      <Select options={global.ar2.perimeterList} value={global.ar2.perimeterList.find(element => element.value === global.ar2.gid_area)} onChange={this.handleChangeAR} defaultValue={global.ar2.gid_area} />
                    </div>
                    <div className="selector quart">
                      <b>Agrégation des zones</b>
                      <Select options={global.ar2.aggList} value={global.ar2.aggList.find(element => element.label === global.ar2.ag)} onChange={this.handleChangeAG} defaultValue={global.ar2.aggList[0]} />
                    </div>
                    <div className="selector quart">
                      <b>Nationalité</b>
                      <Select options={global.optionsNT} value={global.optionsNT.find(element => element.label === global.nat)} onChange={this.handleChangeNT} />
                    </div>
                    <div className="selector quart">
                      <b>Année</b>
                      <Select options={global.optionsYE} value={global.optionsYE.find(element => element.label === global.year)} onChange={this.handleChangeYE} defaultValue={global.optionsYE[0]} />
                    </div>
                </div>
                {this.renderMap()}
            </div>
        )
    }
}

function UpdateMapCentre(props) {
  const map = useMap();
  map.panTo(props.mapCentre);
  return null;
}
